/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-key */
import React, { useState } from 'react';
import { Button, Divider, Form, message, Spin } from 'antd-v5';
import { connect } from 'react-redux';
import { useQuery } from 'react-query';
import StandardLayoutV2 from '../../../../Layout/StandardLayoutV2';
import { getMessageSettings, saveMessageSettings } from '../../../../../core/apiRequests';
import { bodyFormatterApp, messageDispatcher } from '../../../../../components/Routes/Configuration/MessageSettings/largeMsgSettingFns';
import yn from 'yn';
import { AppAccountSettings } from './components/appAccount';
import { ClientelingSettings } from './components/clienteling';
import { SalesPipelineSettings } from './components/salesPipeline';
import { AssociateVisibilitySettings } from './components/associateVisibility';
import { ProductSettingsSection } from './components/productSettings';

const AppSettings = ({ merchantId, merchantFlags, licenseKey, merchantPassword, merchantConfig }) => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const flags = merchantFlags;
  const LIMITED_ASSOCIATE_VISIBILITY = flags?.limited_associate_visibility?.enabled;

  const { isFetching, refetch } = useQuery(
    ['appSettings', merchantId],
    async () => {
      const response = await getMessageSettings('merchant', merchantId);
      if (response) {
        console.log({ response })
        messageDispatcher(response);
        const data = {
          dailyContactGoal: response?.daily_contact_goal || 4,
          salesOppName: response?.SALES_OPP_NAME || '',
          limitAssociateVisibilityEnabled: yn(response?.LIMIT_ASSOCIATE_VISIBILITY_ENABLED) || false,
          hideProductCost: yn(response?.HIDE_PRODUCT_COST) || false,
        };
        form.setFieldsValue(data);
      }
    },
    {
      enabled: !!merchantId,
      refetchOnWindowFocus: false,
    },
  );

  const handleSave = async () => {
    setSaving(true);
    try {
      await form.validateFields();
      const values = await form.validateFields();
      const body = bodyFormatterApp({
        ...values,
        merchantConfig: {
          LIMIT_ASSOCIATE_VISIBILITY_ENABLED: values.limitAssociateVisibilityEnabled,
          HIDE_PRODUCT_COST: values.hideProductCost,
        },
      });
      await saveMessageSettings('merchant', merchantId, body, 'appConfig');
      refetch();
      message.success('App settings saved successfully');
    } catch (error) {
      console.error('Failed to save settings:', error);
      if (error.errorFields && error.errorFields.length > 0) {
        error.errorFields.forEach(err => {
          message.error(err.errors[0]);
        });
      } else {
        message.error('Failed to save App settings');
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <StandardLayoutV2
      title="General Settings"
      description="Configure your settings for the mobile app"
      classProps="flex-col-left"
      maxWidth="650px"
      styleProps={{ justifyContent: 'flex-start' }}
      containerStyles={{ backgroundColor: 'transparent', paddingRight: '32px', maxWidth: '650px' }}
      actions={
        <Button type="primary" onClick={handleSave} loading={saving} disabled={isFetching}>
          Save
        </Button>
      }
    >
      <Spin spinning={isFetching}>
        <Form form={form} layout="vertical" className="w-100-P" disabled={isFetching || saving}>
          <AppAccountSettings licenseKey={licenseKey} merchantPassword={merchantPassword} />
          <Divider />
          <ClientelingSettings form={form} />
          <Divider />
          <SalesPipelineSettings form={form} />
          {yn(LIMITED_ASSOCIATE_VISIBILITY) && (
            <>
              <Divider />
              <AssociateVisibilitySettings form={form} />
            </>
          )}
          <Divider />
          <ProductSettingsSection form={form} />
        </Form>
      </Spin>
    </StandardLayoutV2>
  );
};

const mapStateToProps = state => ({
  merchantId: state.auth.merchantId,
  merchantFlags: state.auth.merchantFlags,
  licenseKey: state.auth.licenseKey,
  merchantPassword: state.auth.merchantPassword,
  merchantConfig: state.auth.merchantConfig,
});
export default connect(mapStateToProps, {})(AppSettings);
